import { MediaModel } from "src/models";
import { isNumber } from "@gemlightbox/core-kit";

export const checkForMedia = (media: MediaModel["id"] | MediaModel, items: Array<MediaModel>) => {
  const mediaId = isNumber(media) ? media : media?.id;
  return !!items.find(({ id }) => id === mediaId);
};
